// CreditBadge — Topbar-Pille mit aktuellem Credit-Stand. Immer sichtbar nach
// Login. Quelle: useCredits(). Zeigt „—" solange der Stand noch lädt.
// Klick → /credits (Aufladen-Page).

import { NavLink } from 'react-router-dom';
import { useCredits } from '@/hooks/use-credits';

export function CreditBadge() {
  const { balance } = useCredits();

  return (
    <NavLink
      to="/credits"
      className="flex items-center gap-1.5 rounded-full border border-slate-700/40 bg-slate-900/60 px-3 py-1 transition hover:border-amber-500/40 hover:bg-slate-900/80"
      title="Credits aufladen"
    >
      <span className="text-amber-400">◆</span>
      <span className="tabular text-slate-200">{balance === null ? '—' : balance}</span>
      <span className="text-slate-400">Credits</span>
    </NavLink>
  );
}
